import { useQuery } from '@apollo/client';

import {
  CARPOOL_TRIPS,
  CarpoolTripsQuery,
  CarpoolTripsQueryVariables,
} from '../graphql/query/carpoolTripsQuery.graphql';

export const useCarpoolTripsQuery = (eventId: string | null) => {
  return useQuery<CarpoolTripsQuery, CarpoolTripsQueryVariables>(
    CARPOOL_TRIPS,
    {
      variables: { eventId: eventId ?? '' },
      skip: !eventId,
    },
  );
};
